import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal, FormControl, InputGroup } from 'react-bootstrap';
import { Tokenvalidate, settingvalidate } from '../../hooks/kycvalidation';
import { updatesettinghook, updatetokenhook } from '../../hooks/usebackend';

import proof from "../../images/proof.webp"
import toast from 'react-hot-toast';
import {API_URL} from "../../config/env"

class Edittokenmodal extends Component
{
    constructor(props) {
        console.log("props_props_edit_token",props);
        super(props);
        this.state = {          
            edittokenModal: true,
            //   image: null,
            //  imageFile: null, 
            imageurl:"",
            settingname : "",
            settingvalue : "",
            errors : {},
            Address:"",
            Decimal:"",
           // Image:"",
            Name:"",
            Symbol:"",
            chainid:"",
            Status:"",
            TokenselectedValue:"",
            Currencytype:""
            
            
        };
    }

//      onImageChange = event => {
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];

//     this.setState({
//       imageFile: file,                // store file for upload
//       image: URL.createObjectURL(file) // preview
//     });
//   }
// };


// handleImageUpload = async () => {
//   const { imageFile } = this.state;
//   if (!imageFile) {
//     toast.error("Please select an image first");
//     return;
//   }

//   console.log("Uploading file:", imageFile);

//   // Example upload (use your API logic)
//   const formData = new FormData();
//   formData.append("banner_image", imageFile);

//   // Example API call
//   // let resp = await axios.post("API_URL", formData);

//   toast.success("Image upload triggered!");
// };

handleChange = (event) => {
    this.setState({ Status: event.target.value });
  };
  handleChangeToken = (event) => {
    this.setState({ Currencytype: event.target.value });
  };

    componentDidMount(){
        
        if(!this.state.Address && !this.state.Address){
            this.setState({"Address" : this.props.data.Address});
            this.setState({"Name" : this.props.data.Name});
            this.setState({"Symbol" : this.props.data.Symbol});  
             this.setState({"Decimal" : this.props.data.Decimal});
             this.setState({"chainid" : this.props.data.chainid});
            //  this.setState({"Image" : this.props.data.Image});
             this.setState({"imageurl" : this.props.data.imageurl});

             
             this.setState({"Status" : this.props.data.Status});
             this.setState({"Currencytype" : this.props.data.Currencytype});


             
        }
    }
    handleedit = async()=>{
        let payload = {
            id : this.props.data?._id,
            address : this?.state?.Address,
            name : this?.state?.Name,
            symbol : this?.state?.Symbol,
            decimal : String(this?.state?.Decimal),
            chainid : String(this?.state?.chainid),
            imageurl:this?.state?.imageurl,
            // image :  this.state.imageFile ? this.state.imageFile : this.props.data.Image,
            status : this?.state?.Status,
            Currencytype : this?.state?.Currencytype,

            
           
        }
        console.log("payload--------",payload);
        let validate = await Tokenvalidate(payload);
        if(validate?.isValid){
            let result = await updatetokenhook(payload);
            this.props.onDismiss();
            this.props.getset()
            this.props.onreload()
        }
        else{
            this.setState({"errors" : validate?.errors})
        }
    }


   render() {
        
  {console.log("Token_select_",this.state.TokenselectedValue)}
 {console.log("handleImageUpload_handleImageUpload",this.state.imageFile);}
        const {edittokenModal} = this.state

        
      return (

        

        <Modal className="wallet-modal" show={edittokenModal} centered size="md">
        <Modal.Header className='pt-3 header_odal_head'>
        <h3 className="sec-head ">Edit Token</h3>
            <button type="button" class="close" onClick={() => this.props.onDismiss()}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>

        </Modal.Header>
        <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-0">

        <div className="wallet-lists px-2">
                              
        <div className='mod_pad_space pt-0'>
        <div className='row'>
                <div className='col-12 col-md-12 px-1 mb-3'>
                        
                        
                        
                       </div>
                        {/* <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Setting Name</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="settingname"  placeholder="Setting Name"
                                aria-describedby="basic-addon2"
                                value = {this.state.settingname}
                                onChange ={(e)=>{
                                    this.setState({"settingname" : e?.target?.value})
                                }}
                                disabled
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                    </div>                    
                        </div>

                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Setting Value</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="hardcap" value={this?.state?.settingvalue} placeholder="Setting Value"
                                aria-describedby="basic-addon2"
                                onChange={(e)=>{
                                    this.setState({"settingvalue" : e?.target?.value})
                                }}
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                    </div>
                        </div>  */}

                          <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Token Address</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="Address"  placeholder="Token Name"
                                aria-describedby="basic-addon2"
                                 value = {this.state.Address}
                                onChange ={(e)=>{
                                    this.setState({"Address" : e?.target?.value})
                                }}
                                
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.address}</span>
                    </div>                    
                        </div>


                         <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Token Name</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="Name"  placeholder="Token Decimal"
                                aria-describedby="basic-addon2"
                                 value = {this.state.Name}
                                onChange ={(e)=>{
                                    this.setState({"Name" : e?.target?.value})
                                }}
                                
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.name}</span>
                    </div>                    
                        </div>

                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Token Symbol </p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="Symbol"  placeholder="Token Symbol"
                                aria-describedby="basic-addon2"
                                 value = {this.state.Symbol}
                                onChange ={(e)=>{
                                    this.setState({"Symbol" : e?.target?.value})
                                }}
                                
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.symbol}</span>
                    </div>                    
                        </div>

                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Token Decimal</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="Decimal"  placeholder="Token Decimal"
                                aria-describedby="basic-addon2"
                                 value = {this.state.Decimal}
                                onChange ={(e)=>{
                                    this.setState({"Decimal" : e?.target?.value})
                                }}
                                
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.decimal}</span>
                    </div>                    
                        </div>
                        <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Token chainid</p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="chainid"  placeholder="Token chainid"
                                aria-describedby="basic-addon2"
                                 value = {this.state.chainid}
                                onChange ={(e)=>{
                                    this.setState({"chainid" : e?.target?.value})
                                }}
                                
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.chainid}</span>
                    </div>                    
                        </div>

                        <div className='col-12 col-md-12 px-1 mb-3'>
                                <label>Select Option: </label>

      <select className="form-control custm_sel" 
                         value={this?.state?.Status}
                         placeholder="Select Status"
                         onChange={this.handleChange}
                        >
                            <option value="">Select Status</option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>                      

                        </select>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.status}</span>

                        </div>
                           <div className='col-12 col-md-12 px-1 mb-3'>
                                <label>Select Option: </label>

      <select className="form-control custm_sel" 
                         value={this?.state?.Currencytype}
                         placeholder="Select Status"
                         onChange={this.handleChangeToken}
                        >
                            <option value="">Select Status</option>
                            <option value="Token">Token</option>
                            <option value="Coin">Coin</option>                      

                        </select>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.status}</span>

                        </div>
                                {/* <div className='col-12 col-md-12 px-1 mb-5'>
                                    <p className='input_desc_sm'>Token Image</p>
                                    <div className='position-relative'>
                                        <input type="file" className='listedimg fileimg' name="myImage" onChange={this.onImageChange} />
                                        <button className="get-started-btn uploadedbtn" onClick={this.handleImageUpload}>
                                        Upload
                                       </button>
                                    </div>
                                      {this.state.Image && (
        <img 
            className='img-fluid imgset' 
            src={this.state.imageFile ?   this.state.image :     `${API_URL}/Token_images/${this.state.Image}`} 
            alt="banner preview"
        />
    )}
                                
                                </div>
                        */}
          
          <div className='col-12 col-md-12 px-1 mb-3'>
                    <p className='input_desc_sm'>Token Imageurl </p>
                    <div className="inputs input-groups">
                        <InputGroup className="">
                            <FormControl id="imageurl"  placeholder="Token imageurl"
                                aria-describedby="basic-addon2"
                                 value = {this.state.imageurl}
                                onChange ={(e)=>{
                                    this.setState({"imageurl" : e?.target?.value})
                                }}
                                
                            />
                          
                        </InputGroup>
                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.imageurl}</span>
                    </div>                    
                        </div>
         
                    <div className='col-12 col-md-12 px-1 pt-4 text-center'>
                        <button className="get-started-btn mt-2" onClick={this.handleedit}>
                           Save
                        </button>
                        
                        </div>
                </div>

            </div>
    </div>
        </Modal.Body>
    </Modal>



      )
    }

}


export default Edittokenmodal